const soundPlayer = mp3 => {
  const audioElement = document.createElement("audio");
  audioElement.setAttribute("src", mp3);
  audioElement.load();
  return audioElement;
};

export default soundPlayer;



// WEBPACK FOOTER //
// ./src/helpers/soundPlayer.js